import { Trophy, Users, Anchor, Gamepad, Coffee, MessageSquare } from "lucide-react";

interface FeatureItemProps {
  icon: React.ReactNode;
  text: string;
}

const FeatureItem = ({ icon, text }: FeatureItemProps) => (
  <li className="feature-item">
    {icon}
    <span>{text}</span>
  </li>
);

const FeatureList = () => {
  return (
    <section className="mx-auto py-16 relative overflow-hidden">
      <div className="absolute inset-0 bg-wave-pattern opacity-5 bg-cover bg-center bg-no-repeat transform rotate-180"></div>
      <div className="container mx-auto flex justify-center">
        <div className="relative z-10 bg-secondary/20 rounded-xl p-12">
          <h2 className="font-serif font-bold text-3xl md:text-4xl text-center mb-12">What We Offer</h2>

          <div className="grid md:grid-cols-2 gap-12">
            <div>
              <h3 className="font-serif font-bold text-2xl mb-6 text-sunset">Competitive Play</h3>
              <ul className="space-y-4">
                <FeatureItem icon={<Trophy className="w-5 h-5" />} text="Regular Clan Battles participation" />
                <FeatureItem icon={<Users className="w-5 h-5" />} text="Structured training sessions" />
                <FeatureItem icon={<Anchor className="w-5 h-5" />} text="Active Naval Battles engagement" />
              </ul>
            </div>

            <div>
              <h3 className="font-serif font-bold text-2xl mb-6 text-sunset">Community Spirit</h3>
              <ul className="space-y-4">
                <FeatureItem icon={<Gamepad className="w-5 h-5" />} text="Regular division games" />
                <FeatureItem icon={<Coffee className="w-5 h-5" />} text="Weekly fun events" />
                <FeatureItem icon={<MessageSquare className="w-5 h-5" />} text="Active Discord community" />
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeatureList;